$('.houdiniForm').submit(function(event) {
  event.preventDefault();
  var form = $(this);

  form.validate();
  var isFormValid =form.valid();


  if (isFormValid) {
      event.preventDefault();
      grecaptcha.ready(function() {
        grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'formsubmit'}).then(function(token) {
              form.prepend('<input type="hidden" name="token" value="' + token + '">');
              form.prepend('<input type="hidden" name="action" value="formsubmit">');
              form.unbind('submit').submit();
          });;
      });
  }
});
